export default "__VITE_ASSET__CKAhpz91__"